import axios from "axios";
import { useParams } from "react-router-dom";
import { useHttpErrorHandler } from "../../hooks/useHttpErrorHandler";

// TODO: Remove component not needed - look at Fetch/XHR response or console.log the story as needed
export default function StoryRaw(props) {
  const { storyid } = useParams();
  const { httpErrorHandler, errorStatus } = useHttpErrorHandler();

  const handleOpenJson = async () => {
  // build route from path variable (:story)
    let APIPathStory = storyid;
    let API_URL = `${process.env.REACT_APP_FEATURED_API}` + `${APIPathStory}`;
    let axiosT = axios.create({
      baseURL: `${API_URL}`,
      headers: {
        'Authorization': `JWT ${localStorage.getItem('token')}`
      }
    });
    axiosT
      .get("/")
      .then((response) => {
        if (response.status !== 200) {
          const errorDetails = {
            status: response.status,
          };
          console.log("error error: ", response.status);
          throw errorDetails;
        }
        const formattedJson = JSON.stringify(response.data);
        const blob = new Blob([formattedJson], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
      .catch((err) => {
        httpErrorHandler(err);
      })
  };

  if (errorStatus) return <div>API error, status {errorStatus}</div>;

  return (
    <div>
      <button onClick={handleOpenJson}>View JSON Data</button>
    </div>
  );
}
